<template>
  <v-container fluid grid-list-lg text-xs-center style="height: 100%; background: #ffffff" id="ageAssuranceId">
    <v-dialog :width="videoWidth" v-model="video_dialog">
      <v-card
        ><iframe
          :width="videoWidth"
          :height="videoWidth / 1.77"
          :src="selected_video_src"
          frameborder="0"
          allowfullscreen
        ></iframe>
      </v-card>
    </v-dialog>

    <v-layout row wrap>
      <v-layout>
        <v-flex xs12>
          <v-card elevation="0" class="info-card"
            ><v-layout :column="isMobile"
              ><v-flex xl9 lg8 md12 sm12 xs12>
                <v-card-text class="title pa-5" style="font-weight: 400; line-height: 35px !important">
                  On this page, you can find demos for different key technologies developed at Privately SA. These
                  technologies are at the core of our online safety and wellbeing solutions.
                </v-card-text></v-flex
              ><v-flex class="py-4 hidden-sm-and-down">
                <div style="height: 150px">
                  <v-divider style="border: 1px solid #f1f2f5" class="pa" :vertical="isVertical"></v-divider></div
              ></v-flex>
              <v-flex xl4 lg5 md12 sm12 xs12>
                <v-layout align-center justify-center>
                  <v-flex xl6 lg6 md6 sm12 xs12 class="mt-4 mb-4"
                    ><a href="https://accscheme.com/registry/age-assurance/privately-sa/" target="_blank"
                      ><v-img :src="require('@/assets/images/cert.png')" contain /></a
                  ></v-flex>
                  <v-flex xl6 lg6 md6 sm12 xs12 class="mt-4 mb-4"
                    ><a
                      href="https://www.kjm-online.de/service/pressemitteilungen/meldung/kjm-bewertet-altersverifikationssystem-mit-biometrischer-alterskontrolle-positiv"
                      target="_blank"
                      ><v-img :src="require('@/assets/images/kjm.png')" contain /></a
                  ></v-flex> </v-layout
              ></v-flex>
            </v-layout>
          </v-card> </v-flex
      ></v-layout>

      <v-flex xs12 md4 lg3
        ><v-flex class="tag-card"
          ><v-flex xs12>
            <v-layout wrap fill-height
              ><v-flex xs12 class="px-3 py-3" style="text-align: left"
                ><span class="main-category-title">Filter by Tags</span></v-flex
              ><v-flex xs12 style="text-align: left" class="px-3 py-1"
                ><span class="sub-category-title">Use Case:</span></v-flex
              >
              <v-flex style="text-align: left">
                <v-btn
                  :ripple="false"
                  depressed
                  @click="selectTag(use_case)"
                  v-for="(use_case, i) in use_cases"
                  :id="use_case"
                  :key="i"
                  color="#e7fbf1"
                  class="tag-button font-weight-light passive"
                >
                  <span class="tag-text"># {{ use_case }}</span></v-btn
                >
              </v-flex></v-layout
            >
          </v-flex>
          <v-flex xs12>
            <v-layout wrap fill-height>
              <v-flex class="px-3 py-1" xs12 style="text-align: left"
                ><span class="sub-category-title">Modality:</span></v-flex
              >
              <v-flex style="text-align: left">
                <v-btn
                  depressed
                  @click="selectTag(modality)"
                  v-for="(modality, i) in modality"
                  :id="modality"
                  :key="i"
                  color="#e7fbf1"
                  :ripple="false"
                  class="tag-button font-weight-light passive"
                  ><span class="tag-text"># {{ modality }}</span></v-btn
                >
              </v-flex></v-layout
            >
          </v-flex>
        </v-flex>

        <v-flex style="position: sticky; top: 0" class="mt-2 hidden-sm-and-down"
          ><v-flex xs12 class="py-3" style="text-align: left"
            ><span class="main-category-title"></span
            ><v-flex xs12 style="text-align: left" class="py-3"
              ><span
                :class="onAgeAssurance ? 'category-active' : ''"
                @click="$vuetify.goTo('#ageAssuranceId', scrollOptions)"
                class="sub-category-title"
                style="font-size: 18px; cursor: pointer"
                ><v-icon :class="onAgeAssurance ? 'category-active' : ''">{{
                  onAgeAssurance ? "bookmark" : "bookmark_outline"
                }}</v-icon
                >&nbsp; Privacy Preserving Age Assurance
              </span></v-flex
            ><v-flex xs12 style="text-align: left" class="py-1"
              ><span
                :class="onOnlineSafety ? 'category-active' : ''"
                @click="$vuetify.goTo('#onlineSafetyId', scrollOptions)"
                class="sub-category-title"
                style="font-size: 18px; cursor: pointer"
                ><v-icon :class="onOnlineSafety ? 'category-active' : ''">{{
                  onOnlineSafety ? "bookmark" : "bookmark_outline"
                }}</v-icon
                >&nbsp;Privacy Preserving Online Safety</span
              ></v-flex
            ><v-flex xs12 style="text-align: left" class="py-3"
              ><span
                :class="onPet ? 'category-active' : ''"
                @click="$vuetify.goTo('#petId', scrollOptions)"
                class="sub-category-title"
                style="font-size: 18px; cursor: pointer"
                ><v-icon :class="onPet ? 'category-active' : ''">{{ onPet ? "bookmark" : "bookmark_outline" }}</v-icon
                >&nbsp;Privacy Enhancing Technologies (PET)</span
              ></v-flex
            ></v-flex
          ></v-flex
        >
      </v-flex>

      <v-flex xs12 sm8 md8 lg9
        ><v-container grid-list-sm>
          <v-layout row wrap>
            <v-flex xs12 class="text-xs-left">
              <span
                class="main-category-title"
                v-waypoint="{ active: true, callback: onAgeAssuranceWaypoint, options: intersectionOptions }"
                >Privacy Preserving Age Assurance
              </span>
            </v-flex>

            <v-flex xs12 class="text-xs-left mt-2">
              <span class="sub-category-title">Videos: </span>
            </v-flex>
            <v-flex xs12 md6 xl3 lg4 v-for="video in age_assurance_videos" :key="video.id">
              <v-card
                color="#f9fafb"
                elevation="0"
                :height="isMd ? '290px' : '270px'"
                @click="openVideoDialog(video)"
                style="cursor: pointer; border: 1px solid #f1f2f5; border-radius: 16px"
              >
                <v-img
                  :key="video.id"
                  :src="video.img_src"
                  :lazy-src="require('@/assets/images/video-placeholder.png')"
                  style="object-fit: cover"
                  width="100%"
                  height="150"
                  :intersection-options="{ rootMargin: '0px 0px 200px 0px', threshold: 0.1 }"
                />
                <v-card-title primary-title>
                  <div class="title" style="font-weight: 400; line-height: 2rem !important">{{ video.title }}</div>
                </v-card-title>
              </v-card>
            </v-flex>
            <v-flex xs12 class="text-xs-left mt-4"><span class="sub-category-title">Live Demos: </span></v-flex>

            <v-flex
              xs12
              md5
              xl3
              lg4
              v-for="demo in demos"
              :key="demo.id"
              v-show="
                demo.category == 'age_assurance' &&
                (selectedFilters.length == 0 || selectedFilters.every((r) => demo.filter.includes(r)))
              "
            >
              <router-link :to="{ name: demo.routeName, params: demo.routeParams }" tag="div" style="cursor: pointer">
                <div
                  elevation="1"
                  height="125px"
                  :class="demo.cardClass"
                  class="demo-card"
                  :style="{
                    height: isMd ? '160px !important' : '',
                  }"
                >
                  <v-card-title primary-title>
                    <div class="text-xs-left">
                      <ul style="list-style-type: none" class="title">
                        <li>{{ demo.title }}</li>
                      </ul>
                      <div class="mt-2" style="color: #949ba8; font-weight: bold">{{ demo.subtitle }}</div>
                      <p v-if="demo.cardClass == 'textAssure'" style="color: #e32636; font-weight: bold">
                        • Under Maintenance
                      </p>
                    </div>
                  </v-card-title>
                </div>
              </router-link>
            </v-flex>
          </v-layout>
          <v-divider class="mt-4" style="border-style: dashed; color: #f1f2f5"></v-divider>
          <v-layout row wrap class="mt-4">
            <v-flex xs12 class="text-xs-left">
              <span
                class="main-category-title"
                id="onlineSafetyId"
                v-waypoint="{ active: true, callback: onOnlineSafetyWaypoint, options: intersectionOptions }"
                >Privacy Preserving Online Safety
              </span>
            </v-flex>
            <v-flex xs12 class="text-xs-left mt-2">
              <span class="sub-category-title">Videos: </span>
            </v-flex>
            <v-flex xs12 xl3 lg4 md6 v-for="video in online_safety_videos" :key="video.id">
              <v-card
                color="#f9fafb"
                elevation="0"
                height="250px"
                @click="openVideoDialog(video)"
                style="cursor: pointer; border: 1px solid #f1f2f5; border-radius: 16px"
              >
                <v-img
                  v-lazy
                  :src="video.img_src"
                  :lazy-src="require('@/assets/images/video-placeholder.png')"
                  style="object-fit: cover"
                  width="100%"
                  height="150"
                  :key="video.id"
                />
                <v-card-title primary-title>
                  <div class="title" style="font-weight: 400; line-height: 2rem !important">{{ video.title }}</div>
                </v-card-title>
              </v-card>
            </v-flex>
            <v-flex xs12 class="text-xs-left mt-4"><span class="sub-category-title">Live Demos: </span></v-flex>
            <v-flex
              xs12
              md5
              xl3
              lg4
              v-for="demo in demos"
              :key="demo.id"
              v-show="
                demo.category == 'online_safety' &&
                (selectedFilters.length == 0 || selectedFilters.every((r) => demo.filter.includes(r)))
              "
            >
              <router-link :to="{ name: demo.routeName, params: demo.routeParams }" tag="div" style="cursor: pointer">
                <div height="120px" :class="demo.cardClass" class="demo-card">
                  <v-card-title primary-title>
                    <div class="text-xs-left">
                      <ul style="list-style-type: none" class="title">
                        <li>{{ demo.title }}</li>
                      </ul>
                      <div class="mt-2" style="color: #949ba8; font-weight: bold">
                        {{ demo.subtitle }}
                      </div>
                    </div>
                  </v-card-title>
                </div>
              </router-link>
            </v-flex>
          </v-layout>
          <v-divider class="mt-4" style="border-style: dashed; color: #f1f2f5"></v-divider>
          <v-layout row wrap class="mt-4">
            <v-flex xs12 class="text-xs-left">
              <span class="main-category-title" id="petId">Privacy Enhancing Technologies (PET)</span>
            </v-flex>
            <v-flex xs12 class="text-xs-left mt-2">
              <span class="sub-category-title">Videos: </span>
            </v-flex>
            <v-flex xs12 xl3 lg4 md6 v-for="video in federated_learning_videos" :key="video.id">
              <v-card
                color="#f9fafb"
                elevation="0"
                height="270px"
                @click="openVideoDialog(video)"
                style="cursor: pointer; border: 1px solid #f1f2f5; border-radius: 16px"
              >
                <v-img
                  :src="video.img_src"
                  style="object-fit: cover"
                  width="100%"
                  height="150"
                  :lazy-src="require('@/assets/images/video-placeholder.png')"
                />

                <v-card-title primary-title>
                  <div class="title" style="font-weight: 400; line-height: 2rem !important">{{ video.title }}</div>
                </v-card-title>
              </v-card>
            </v-flex>
            <div v-waypoint="{ active: true, callback: onPetWaypoint, options: intersectionOptions }"></div>
          </v-layout> </v-container
      ></v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  data() {
    return {
      scrollOptions: {
        duration: 300,
        offset: 0,
        easing: "easeInOutCubic",
      },
      intersectionOptions: {
        root: null,
        rootMargin: "0px 0px 0px 0px",
        threshold: [0, 1],
      },
      windowTop: 0,
      onAgeAssurance: true,
      onOnlineSafety: false,
      onPet: false,
      video_dialog: false,
      selected_video_src: "",
      age_assurance_videos: [
        {
          title: "Zero Data Age Assurance: Privacy preserving On-Browser implementation",
          url: "https://youtube.com/embed/XLQeafp10bo",
          img_src: require("@/assets/images/zero-data-min.jpg"),
          id: 11,
        },
        {
          title: "Age Appropriate Advertizing in Web 3.0",
          url: "https://youtube.com/embed/615mPeKxR_k",
          img_src: require("@/assets/images/age-appropriate-min.jpg"),
          id: 22,
        },
        {
          title: "On- Device Age Verification (NFC ID Check)",
          url: "https://youtube.com/embed/kj5ai_uWGok",
          img_src: require("@/assets/images/on-device-min.jpeg"),
          id: 33,
        },
      ],
      online_safety_videos: [
        {
          title: "Preventing Child Sexual Abuse",
          url: "https://youtube.com/embed/GFnysaO60Hg",
          img_src: require("@/assets/images/child-abuse-min.jpeg"),
          id: 44,
        },
        {
          title: "Hate/Toxicity Reduction through nudges",
          url: "https://youtube.com//embed/_B7pJksXi_w",
          img_src: require("@/assets/images/hate-toxicity-min.jpeg"),
          id: 55,
        },
      ],
      federated_learning_videos: [
        {
          title: "Federated Learning - Training Models from Decentralized Data",
          url: "https://youtube.com/embed/Zww6hceXgws",
          img_src: require("@/assets/images/federated-learning-min.jpeg"),
          id: 66,
        },
        {
          title: "Federated Learning On-Device",
          url: "https://youtube.com/embed/_3u8Hotxrhs",
          img_src: require("@/assets/images/fl-ondevice.jpg"),
          id: 77,
        },
      ],
      show: true,
      selectedTag: "",
      selectedFilters: [],
      drawer: null,
      use_cases: ["age-estimation", "geniuneness", "online-safety", "emotions"],
      modality: ["image", "voice", "text"],
    };
  },
  watch: {
    video_dialog: function (newValue) {
      if (!newValue) {
        this.selected_video_src = "";
      }
    },
  },
  methods: {
    onAgeAssuranceWaypoint({ going, direction }) {
      if (going === this.$waypointMap.GOING_IN) {
        this.onAgeAssurance = true;
      }
      if (going === this.$waypointMap.GOING_OUT || direction === this.$waypointMap.DIRECTION_TOP) {
        this.onAgeAssurance = false;
      }
    },

    onOnlineSafetyWaypoint({ going }) {
      if (going === this.$waypointMap.GOING_OUT) {
        this.onOnlineSafety = false;
      }
      if (going === this.$waypointMap.GOING_IN) {
        this.onOnlineSafety = true;
      }
    },

    onPetWaypoint({ going }) {
      if (going === this.$waypointMap.GOING_IN) {
        this.onPet = true;
      }
      if (going === this.$waypointMap.GOING_OUT) {
        this.onPet = false;
      }
    },
    openVideoDialog(item) {
      this.video_dialog = true;
      this.selected_video_src = item.url;
    },
    selectTag(value) {
      this.selectedTag = value;
      if (this.selectedFilters.includes(value)) {
        document.getElementById(value).classList.add("passive");
        document.getElementById(value).classList.remove("active");
        this.selectedFilters = this.removeItemOnce(this.selectedFilters, value);
      } else {
        document.getElementById(value).classList.add("active");
        document.getElementById(value).classList.remove("passive");

        this.selectedFilters.push(value);
      }
    },
    removeItemOnce(arr, value) {
      var index = arr.indexOf(value);
      if (index > -1) {
        arr.splice(index, 1);
      }
      return arr;
    },
  },
  computed: {
    ...mapGetters("common", {
      pageElements: "pageElements",
    }),
    videoWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 350;
        case "sm":
          return 500;
        case "md":
          return 763;
        case "lg":
          return 763;
        case "xl":
          return 763;
      }
    },
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs" || this.$vuetify.breakpoint.name === "sm";
    },
    isMd() {
      return (this.$vuetify.breakpoint.name = "md");
    },
    isVertical() {
      return (
        this.$vuetify.breakpoint.name == "lg" ||
        this.$vuetify.breakpoint.name == "xl" ||
        this.$vuetify.breakpoint.name == "md"
      );
    },
    demos() {
      let items = [
        {
          title: "AgeAssure - Multimodal Demo",
          subtitle: "Facial and Voice Analysis for Age determination (no anti-spoof)",
          routeName: "ageassure",
          routeParams: {},
          dark: true,
          filter: ["age-estimation", "image", "voice"],
          category: "age_assurance",
          cardClass: "ageAssure",
          id: 111,
        },
        {
          title: "FaceAssure",
          subtitle: "Coarse-grained Age Estimation using Facial Analysis",
          routeName: "faceassure",
          routeParams: {},
          dark: true,
          filter: ["age-estimation", "geniuneness", "image"],
          category: "age_assurance",
          cardClass: "faceAssure",
          id: 222,
        },
        {
          title: "VoiceAssure",
          subtitle: "Age Estimation using Voice Analysis - with Antispoofing",
          routeName: "audio_recording",
          routeParams: {},
          dark: true,
          filter: ["age-estimation", "geniuneness", "voice"],
          category: "age_assurance",
          cardClass: "voiceAssure",
          id: 333,
        },
        {
          title: "TextAssure",
          subtitle: "Estimate a user's age from input text",
          routeName: "",
          routeParams: {},
          dark: true,
          explanation: "This demo includes classifiers for estimating a user's age",
          filter: ["age-estimation", "text"],
          category: "age_assurance",
          cardClass: "textAssure",
          id: 444,
        },
        {
          title: "Voice Similarity",
          subtitle: "Reports if two audio samples come from the same speaker",
          routeName: "voice_print",
          routeParams: {},
          dark: true,
          filter: ["geniuneness", "text"],
          category: "age_assurance",
          cardClass: "voiceSimilarity",
          id: 555,
        },
        {
          title: "On-Browser Voice Captcha",
          subtitle: "Check if your form is filled by a geniune person",
          routeName: "voice_captcha_demo",
          routeParams: {},
          dark: true,
          filter: ["geniuneness", "voice"],
          category: "age_assurance",
          cardClass: "voiceCaptcha",
          id: 666,
        },
        {
          title: "Restricted Retail",
          subtitle: "Age Verification for Online Retail",
          routeName: "restrictedretail",
          routeParams: {},
          dark: true,
          filter: ["age-estimation", "geniuneness", "image"],
          category: "age_assurance",
          cardClass: "restrictedRetail",
          id: 777,
        },
        {
          title: "CSAM Images Detection",
          subtitle: "Detecting nudity and age in images",
          routeName: "csam_demo",
          routeParams: {},
          dark: true,
          explanation: "",
          filter: ["age-estimation", "online-safety", "image"],
          category: "online_safety",
          cardClass: "csamDetection",
          id: 888,
        },
        {
          title: "Hate & Toxicity",
          subtitle: "Evaluating online speech in multiple languages",
          routeName: "hate_toxicity",
          routeParams: {},
          dark: true,
          explanation: "This demo includes classifiers for detecting hate speech and toxicity.",
          filter: ["online-safety", "emotions", "text"],
          category: "online_safety",
          cardClass: "hateToxicity",
          id: 999,
        },

        {
          title: "Emotion Analysis in Text",
          subtitle: "Angry? Joyful? Neutral? or What?",
          routeName: "emotion",
          routeParams: {},
          dark: true,
          explanation: "",
          filter: ["emotions", "text"],
          category: "online_safety",
          cardClass: "emotionAnalysis",
          id: 1111,
        },

        {
          title: "Nudity Detection",
          subtitle: "Detection of nudity in images",
          routeName: "nudity_demo",
          routeParams: {},
          dark: true,
          explanation: "",
          filter: ["online-safety", "image"],
          category: "online_safety",
          cardClass: "nudityDetection",
          id: 2222,
        },
      ];
      for (const item of items) {
        try {
          item.color = this.pageElements[item.routeName].color;
          item.img = this.pageElements[item.routeName].img;
        } catch (e) {}
      }

      return items;
    },
  },
};
</script>

<style scoped>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.5;
  position: absolute;
  width: 100%;
}

.category-active {
  color: #1d87b4;
}

.active.theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
  border: 1px solid #0a533c !important;
  width: 120px;
  height: 30px;
  box-sizing: border-box;
  background-image: linear-gradient(#cdfae2, #e7fcf2);
  border-radius: 8px;
}

.passive.theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
  background-color: #f5f5f5;
}
</style>
